import { Aside1Section, BackgroundBanner, SpecialDetail, SpecialPreview, TopSection } from "@/domains/components";
import { useGetDMaxCommon, type Aside1DmaxInfoResponse, type SpecialDmaxInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

export const Specials = () => {
    const { specialIdx } = useParams<string>();
    const { data: special } = useGetDMaxCommon<SpecialDmaxInfoResponse>({ section: "special" });
    const { data: aside1 } = useGetDMaxCommon<Aside1DmaxInfoResponse>({ section: "aside1" });

    const targetSpecial = special?.specials.find((t) => t.special_idx === specialIdx);
    const sector = {
        main: {
            firstLine: targetSpecial?.special_name.eng || "",
            secondLine: targetSpecial?.special_name.kor || "",
        },
        sub: {
            firstLine: "",
            secondLine: "",
        },
    };

    const otherSpecialList = special?.specials.filter((t) => t.special_idx !== specialIdx);
    if (!specialIdx) {
        // 404로 요청
        return <div>404로 요청합니다</div>;
    }

    return targetSpecial && aside1 && otherSpecialList ? (
        <>
            <TopSection imgList={targetSpecial?.imgList} sector={sector} />
            <SpecialDetail special={targetSpecial} />
            <SpecialPreview special={{ specials: otherSpecialList }} />
            <BackgroundBanner img_URL={targetSpecial.imgList[0].img_URL} />
            <Aside1Section aside1={aside1} />
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
